import { FC } from 'react';
import AlertDialog from 'components/AlertDialog';
import Typography from '@mui/material/Typography';
import { Disclosure } from 'further-ui/hooks';

type Props = {
  disclosure: Disclosure;
  canAffordNewFees?: boolean;
};

const NegativeBalanceErrorModal: FC<Props> = ({
  disclosure,
  canAffordNewFees,
}) => (
  <AlertDialog
    open={disclosure.isOpen}
    title="Negative balance error"
    content={
      <>
        {canAffordNewFees ? (
          <Typography>
            Due to transactions (allocations and/or fees) processed on this
            subscription, there are insufficient funds available to change the
            total commitment as requested.
            <br />
            <br />
            Please review all subscription transactions and delete or amend them
            before making this change.
          </Typography>
        ) : (
          <Typography>
            There are not enough funds available on this subscription to pay the
            fees applied by the new preset. If you wish to change this
            subscription’s fees, please either increase the total commitment or
            use another fee preset.
          </Typography>
        )}
      </>
    }
    onClose={disclosure.onClose}
    btnLabels={{
      confirm: false,
      cancel: 'OK',
    }}
  />
);

export default NegativeBalanceErrorModal;
